import script from "./GuestNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestNavbar.vue?vue&type=script&setup=true&lang=js"

import "./GuestNavbar.vue?vue&type=style&index=0&id=0df4dbb5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0df4dbb5"]])

export default __exports__